import { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Zoom from "./screen/zoom";
import "./App.css";

function App() {
  return (
    <Zoom></Zoom>
    // <Routes>
    //   <Route path="/" element={<Zoom />} />
    //   <Route path="/tokenZoom" element={<TokenZoom />} />
    //   <Route path='/zoomweb' element={<ZoomWeb />} />
    // </Routes>
  );
}

export default App;
